// "$1,234.56", "-$87.23", "$12.00 CAD": an amount the way users should read
// it. en-CA grouping, always two decimals, and the minus sign before the $.
// Pass { currency: "CAD" } (or "USD") to add the code after the amount.
// Blank or unreadable values (null, undefined, "", "abc") read as "—".
// For display only: send the API the raw value, never this text.
const AMOUNT = new Intl.NumberFormat("en-CA", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatMoney = (value, options) => {
  if (typeof value !== "number" && typeof value !== "string") return "—";
  if (typeof value === "string" && value.trim() === "") return "—";
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";

  const digits = AMOUNT.format(Math.abs(amount));
  // -0.001 shows as $0.00, not -$0.00.
  const sign = amount < 0 && digits !== "0.00" ? "-" : "";
  const currency = options?.currency
    ? ` ${String(options.currency).trim().toUpperCase()}`
    : "";
  return `${sign}$${digits}${currency}`;
};
